export const LABELS = {
  printCopyScan: 'Print, Copy, Scan',
  wirelessCapability: 'Wireless capability',
  photoTray: 'Photo Tray',
  lcd: 'LCD touch screen',
  memoryCard: 'USB memory card host',
  builtInFax: 'Built-in fax',
  autoDocFeeder: 'Auto document feeder',
  ethernetNetworking: 'Ethernet networking',
  printSpeed: 'Print speed, max ppm',
  paperInput: 'Paper input, sheets',
  adfCapacity: 'ADF capacity, sheets',
  aiEnhanced: 'AI Enhanced'
};
export const PrinterType = {
  Cartridge: 'Ink Cartridge printer',
  Tank: 'Ink Tank printer'
} as const;

export type PrinterTypeKey = keyof typeof PrinterType;
